import React from 'react'
import { useReportTypes } from '/src/app/root/hooks/useReportTypes'
import { GetMarkerIcon } from '/src/app/locations/utils/get-marker-icon'
import { useStyles } from '../storage-section.styles'
import { Grid, Typography, Tooltip } from '@material-ui/core'
import { SubStr } from '../../../components/substr'

export const GridItem = ({
    floorPlanDevice,
    onClick,
    setActiveBlur,
    isMobile
}) => {
    const { severity } = useReportTypes(floorPlanDevice?.last_report_type)
    const isNetworkDevice = floorPlanDevice.hasOwnProperty('router_type')
    const floorDeviceIcon = GetMarkerIcon(
        severity,
        isNetworkDevice,
        floorPlanDevice
    )
    const classes = useStyles()

    const onDragStart = e => {
        e.dataTransfer.setData(`dragged`, JSON.stringify(floorPlanDevice))
        setActiveBlur(true)
    }

    return (
        <Tooltip
            className={classes.tooltip}
            title={floorPlanDevice?.name || floorPlanDevice?.serial_number}
            placement="top">
            <Grid
                draggable
                onDragStart={onDragStart}
                onMouseLeave={() => {
                    setActiveBlur(false)
                }}
                item
                xs={isMobile ? 3 : 12}
                md={6}
                lg={4}
                xl={3}
                onClick={onClick}
                className={classes.itemWrapper}>
                <>
                    <img
                        className={classes.image}
                        src={floorDeviceIcon?.options?.iconUrl}
                    />

                    <Typography className={classes.paragraph}>
                        <SubStr to={isMobile ? 8 : 5}>
                            {floorPlanDevice?.name ||
                                floorPlanDevice?.serial_number}
                        </SubStr>
                    </Typography>
                </>
            </Grid>
        </Tooltip>
    )
}
